export enum VirtualizationState {
  VIRTUALIZED = 'virtualized',
  DEVIRTUALIZED = 'devirtualized',
  REVIRTUALIZED = 'revirtualized',
}

export function getVirtualizationState(
  revirtualizationEnabled: boolean,
  mayVirtualize: boolean,
  hasNotDevirtualized: boolean
): VirtualizationState {
  if (!mayVirtualize) {
    return VirtualizationState.DEVIRTUALIZED;
  }
  if (!revirtualizationEnabled) {
    return hasNotDevirtualized ? VirtualizationState.VIRTUALIZED : VirtualizationState.DEVIRTUALIZED;
  }
  return hasNotDevirtualized ? VirtualizationState.VIRTUALIZED : VirtualizationState.REVIRTUALIZED;
}
